// eslint-disable-next-line @typescript-eslint/no-explicit-any

import { QueryArchiveInfo, QueryResponseTextRecordItem, QuerySurveyInfo, ChatBotEvent } from "@/service";
import { QueryAttachmentInfo } from "@/service/models/QueryAttachmentInfo";
import { QueryInteractionDisplayItem } from "@/service/models/QueryInteractionDisplayItem";
import { QueryInteractionResponseItem } from "@/service/models/QueryInteractionResponseItem";
import { TermsParameterType } from "../terms/types";

export { QueryInteractionDisplayItem } from "@/service/models/QueryInteractionDisplayItem";
export type TranslationType = QueryResponseTextRecordItem;

export type QueryHeaderType = QueryInteractionDisplayItem;

export type QueryResponseType = QueryInteractionResponseItem;

export type CloningQueryDetails = ChatBotEvent & {
  cloningValue?: boolean
}

export interface QueryStoreInterface {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  query: QueryHeaderType | null;
  responses: QueryResponseType[];
  rejectedExpertResponses: QueryResponseType[];
  participantIds: number[]; // Used for colors
  participantColorIndex: Record<string, number>;
  lastResponseId: number;
  moreRecords: boolean; // Responses for currently loaded query
  responseDraftCacheId: string | null;
  queryBuilderConfigItems: any[];
  clonedQueryDetails: CloningQueryDetails | null;

  // Getters
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly currentQuery: QueryHeaderType | null;
  readonly loadedResponses: QueryResponseType[];
  readonly getRejectedResponses: QueryResponseType[];
  readonly surveyInfo: QuerySurveyInfo | null;
  readonly colorIndex: Record<string, number>;
  readonly endUserResponseTypes: string[];
  readonly hasMoreRecords: boolean;
  readonly responseDraftId: string | null;
  readonly getConfigItems: any[];
  readonly getClonedQueryDetails: CloningQueryDetails | null;

  // Mutations
  setQuery(q: QueryHeaderType | null): void;
  setClonedQueryDetails(q: CloningQueryDetails | null): void,
  setResponses(r: QueryResponseType[]): void;
  addResponses(r: QueryResponseType[]): void;
  setRejectedResponses(r: QueryResponseType[]): void;
  addRejectedResponses(r: QueryResponseType[]): void;
  clearParticipants(): void;
  setParticipants({ ids, colorMap }: { ids: number[]; colorMap: Record<string, number> }): void;
  setLastResponseId(id: number): void;
  setMoreRecords(b: boolean): void;
  clearQueryData(): void;
  clearResponseDraft(): void;
  setConfigItems(r: any[]): void,

  // Actions
  loadQuery(id: number | string): Promise<QueryHeaderType>;
  updateQuery(id: number | string): Promise<QueryHeaderType>; // Reload just the header
  loadResponses(pagseSize: number): Promise<QueryResponseType[]>;
  postTextResponse({ text, terms }: { text: string; terms?: TermsParameterType }): Promise<void>;
  generateResponseDraftId(qid: string): Promise<void>;
  saveDraftResponse(text: string): Promise<void>;
  getDraftResponse(): Promise<string | undefined>;
  postAttachmentResponse({
    text,
    description,
    file,
    terms
  }: {
    text: string;
    description: string;
    file: File;
    terms?: TermsParameterType;
  }): Promise<void>;
  getAttachmentInfo(id: number | string): Promise<QueryAttachmentInfo>;
  getArchiveInfo(id: number | string): Promise<QueryArchiveInfo>;

  acceptInvitation(payload: { timestamp?: number; unpaid: boolean }): Promise<boolean>;
  declineInvitation(): Promise<boolean>;
}

/**
 * Returns the response row as-is — no wire-to-model mapping needed.
 */
export function mapWireResponseRow(r: QueryResponseType): QueryResponseType {
  return r;
}

/** Row kind from `queryResponseType` field on {@link QueryInteractionResponseItem}. */
export function getResponseRowKind(r: QueryResponseType): string | undefined {
  return r.queryResponseType;
}
